import { CartState } from "slices/booking/cartSlice";

const roundToTwo = (num: number) => Math.round((num + Number.EPSILON) * 100) / 100;
interface AccessibilityOption {
  charges: number;
}

interface BookingTotals {
  additionalCharges: number;
  subTotal: number;
  cleaningDeposit: number;
  vatAmount: number;
  totalWithVAT: number;
  before_discount_amount: number;
  discountAmount?: number;
}

export const calculateBookingTotals = (cartData: Pick<CartState, 'subTotal' | 'cleaningDeposit' | 'vat'>, accessibilityOptions: AccessibilityOption[], deliveryCharges : number, discountAmount : number): BookingTotals => {
  // Calculate additional charges from accessibility options
  const additionalCharges = roundToTwo(accessibilityOptions.reduce(
    (sum: number, option: AccessibilityOption) => sum + Number(option.charges || 0),
    0
  ));

  // Calculate base total including additional charges and cleaning deposit
  const productsTotal = roundToTwo(Number(cartData.subTotal));
  const cleaningDeposit = roundToTwo(Number(cartData.cleaningDeposit));
  const baseTotal = roundToTwo(productsTotal + additionalCharges + cleaningDeposit + deliveryCharges - discountAmount);

  // Calculate VAT
  const vatAmount = roundToTwo(baseTotal * (Number(cartData.vat) / 100));
  
  // Calculate final total with VAT
  const totalWithVAT = roundToTwo(baseTotal + vatAmount);

  const before_discount_amount = roundToTwo(productsTotal + additionalCharges + cleaningDeposit + vatAmount);

  return {
    additionalCharges,
    subTotal : baseTotal,
    cleaningDeposit,
    vatAmount,
    totalWithVAT: totalWithVAT,
    before_discount_amount,
  };
};
